<template>
    <section class="home-container">
        <MasterPage title="特殊问卷绑定">
            <div slot="title-icon">
                <Icon type="ios-pulse" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Alert>
                    <Form :label-width="100">
                        <Row>
                            <Col span="12">
                            <FormItem v-if="!editQuestionnaire.dayQues" label="每日问卷：" style="margin: 0">
                                {{bindQuestionnaire.dayQues ? bindQuestionnaire.dayQues[0].name:'暂未绑定问卷'}}
                            </FormItem>
                            <FormItem v-else label="每日问卷：" style="margin: 0">
                                <Select v-if="bindQuestionnaire.dayQues != null" v-model="bindQuestionnaire.dayQues.id" transfer filterable>
                                    <Option v-for="item in dataList" :key="item.id" :value="item.id">{{item.name}}</Option>
                                </Select>
                            </FormItem>
                            </Col>
                            <Col span="3" offset="1">
                            <Button v-if="!editQuestionnaire.dayQues" type="primary"
                                    icon="md-create" @click="editQuestionnaire.dayQues = !editQuestionnaire.dayQues">修改</Button>
                            <Button v-else type="primary" icon="md-save" @click="updateDaily">保存</Button>
                            </Col>
                        </Row>
                    </Form>
                </Alert>
            </div>
        </MasterPage>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    export default {
        components:{
            MasterPage
        },
        data(){
            return{
                dataList:[],
                editQuestionnaire:{
                    dayQues: false
                },
                bindQuestionnaire:{
                    dayQues: null,
                }
            }
        },
        created(){
            this.findBindQuestionnaire()
        },
        methods:{
            findBindQuestionnaire(){
                this.$http.post('questionnaire/list',{
                    isDeleted:false,
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.bindQuestionnaire.dayQues = this.dataList.filter(item => item.isDaily)
                    }else {
                        this.$Notice.error({title:'组卷查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            updateDaily () {
                this.$http.post('questionnaire/updateDaily',{
                    id: this.bindQuestionnaire.dayQues.id
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '每日问卷修改成功'});
                        this.editQuestionnaire.dayQues =  false
                        this.findBindQuestionnaire()
                    }else {
                        this.$Notice.error({title:'每日问卷修改',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            }
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }
</style>


